module.exports = __webpack_public_path__ + "static/media/plants 1.524e8681.png";